const INTERNAL_DOMAIN = '@teramot.com';

export const isInternalTeramotEmail = (email: string | null | undefined): boolean =>
  (email ?? '').trim().toLowerCase().endsWith(INTERNAL_DOMAIN);
